import React from "react";
import { colors } from "src/theme/colors";
import styled from "styled-components";

export interface SliderTitleProps {
  title: string;
  subtitle?: string;
  /** Kept for the callers that mark the solved figure. */
  green?: boolean;
  optional?: boolean;
}

/**
 * A field's label.
 *
 * ONE label, not two. Every field on this form carried a bold name and,
 * under it, the same thing again in the first person — "Investment Initial
 * Amount" over "If I Would Like to Start with:", "Contribution Amount" over
 * "If I Would Like To Contribute:". A paraphrase is not a hint: it adds no
 * constraint, no unit and no default, so a reader has to read both to
 * discover that the second one says nothing, and then decide which is
 * authoritative. The name stays; the paraphrase goes unless a caller passes
 * something that actually tells the reader something.
 *
 * "(Optional)" stays too, in the label's own ink rather than beside it in
 * another weight — it is a property of the field, and the one piece of the
 * old subtitle that was information.
 */
const Wrap = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
`;

const Name = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.gray[900]};
`;

const Optional = styled.span`
  font-size: 11.5px;
  font-weight: 400;
  color: ${colors.gray[400]};
`;

const Hint = styled.span`
  font-size: 11.5px;
  color: ${colors.gray[500]};
`;

export const StyledSubtitle = styled.span`
  display: block;
  font-size: 11.5px;
  color: ${colors.gray[500]};
  margin-bottom: 4px;
`;

export const SliderTitle: React.FC<SliderTitleProps> = ({
  title,
  subtitle,
  optional,
}) => (
  <Wrap>
    <Name>{title}</Name>
    {optional ? <Optional>Optional</Optional> : null}
    {subtitle ? <Hint>{subtitle}</Hint> : null}
  </Wrap>
);
